<template functional>
  <div
    :class="data.staticClass"
    class="container"
    v-bind="{...data.attrs, [parent.$options._scopeId]: ''}"
    v-on="listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Container',
}
</script>

<style scoped lang="scss">
.container {
  padding: 25px 15px;
}
</style>
